import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";
import FormData from "form-data";


import axios from "axios";

function DPStatement() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    "Document Type": "",
    DP_ID: "",
    Client_ID: "",
    Name: "",
    Pan_Number: "",
    Contact_No: "",
    Email: "",
    District: "",
    State: "",
    Pin_Code: "",
    Period_From: "",
    Bill_Date_TO: "",
    Due_Date: "",
    status: "",
    Frozen_status: "",
    GST_Invoice: "",
    Statename: "",
    Branch: "",
    Nominee: "",
    GST_NO: "",
    subtype: "",
    Trading_Code: "",
    Trading_ID: "",
    Address: "",
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true);

  useEffect(() => {
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      "Document Type": "",
      DP_ID: "",
      Client_ID: "",
      Name: "",
      DOB: "",
      Pan_Number: "",
      Contact_No: "",
      Email: "",
      Pincode: "",
      Period_From: "",
      Bill_Date_TO: "",
      Due_Date: "",
      status: "",
      Frozen_status: "",
      GST_Invoice: "",
      Statename: "",
      Branch: "",
      Nominee: "",
      GST_NO: "",
      subtype: "",
      Trading_Code: "",
      Trading_ID: "",
      Address: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
           method: "post",
      url: "https://2ahcrc4yo8.execute-api.ap-south-1.amazonaws.com/default/DPSTATEMENT_OCRSERVICE",
      
      headers: {
        "x-api-key": "y9VP9ScmBp4P3ZLMMugc6ggq9EbKWap4CdGaJHzg",
        authorizationToken: "aG0W0FNbM2saT46i",
      },
    
      data: data,
    };

    axios(config) 
      .then(function (response) {
        console.log(JSON.stringify(response.data));
   
        setCardData(response.data);
        setLoading(true);
      })
      .catch(function (error) {
        setLoading(true);
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, 

  [cardData]);

  return (
    <div>
      <div>
        <div class="container containerBoreder " id="pan">
         
          <h2 class="pageTitle">DP Statement OCR</h2>
          <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
            
          </div>
          <br />
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Documemt Type </th>
                <td>{cardData.Document_Type}</td>
              </tr>
              <tr>
                <th>DP ID:</th>
                <td>{cardData.DP_ID}</td>
              </tr>
              <tr>
                <th>Client ID</th>
                <td>{cardData.Client_ID}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{cardData.Name}</td>
              </tr>
              <tr>
                <th>Pan Number</th>
                <td>{cardData.Pan_Number}</td>
              </tr>
              <tr>
                <th>Contact Number</th>
                <td>{cardData.Contact_No} </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{cardData.Email} </td>
              </tr>
              <tr>
                <th>Pin Code</th>
                <td>{cardData.Pincode} </td>
              </tr>
              <tr>
                <th>Period From</th>
                <td>{cardData.Period_From}</td>
              </tr>
              <tr>
                <th>Bill Date to</th>
                <td>{cardData.Bill_Date_TO}</td>
              </tr>
              <tr>
                <th>Due Date</th>
                <td>{cardData.Due_Date}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{cardData.status}</td>
              </tr>
              <tr>
                <th>Frozen Status</th>
                <td>{cardData.Frozen_status}</td>
              </tr>
              <tr>
                <th> GST Invoice</th>
                <td>{cardData.GST_Invoice}</td>
              </tr>
              <tr>
                <th>Nominee</th>
                <td>{cardData.Nominee}</td>
              </tr>
              <tr>
                <th>GST No.</th>
                <td>{cardData.GST_NO} </td>
              </tr>
              <tr>
                <th>Sub Type</th>
                <td>{cardData.subtype}</td>
              </tr>
              <tr>
                <th>Trading Code</th>
                <td>{cardData.Trading_Code}</td>
              </tr>
              <tr>
                <th>Trading ID</th>
                <td>{cardData.Trading_ID} </td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{cardData.Address}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DPStatement;
